module.exports = __webpack_public_path__ + "img/Mahathir_mouth.875991cd.jpg";